import { render, staticRenderFns } from "./SelectionDialog.vue?vue&type=template&id=c04f45f4"
import script from "./SelectionDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectionDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SelectionDialog.vue?vue&type=style&index=0&id=c04f45f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports